import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"arrow-up\">\n<path d=\"M12,20c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1s1,0.4,1,1v14C13,19.6,12.6,20,12,20z\" />\n<path d=\"M19,13c-0.3,0-0.5-0.1-0.7-0.3L12,6.4l-6.3,6.3c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l7-7c0.4-0.4,1-0.4,1.4,0l7,7\n\tc0.4,0.4,0.4,1,0,1.4C19.5,12.9,19.3,13,19,13z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol